// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cc-j";
export var fulfillmentFormRail = "_cc-i";
export var headerTitleRow = "_cc-l";
export var orderDetailsWrapper = "_cc-g";
export var orderLinkTrigger = "_cc-2";
export var paymentInformationGrid = "_cc-q";
export var paymentSummaryColumn = "_cc-r";
export var phoneShipmentPickerButton = "_cc-e";
export var phoneShipmentPickerButtonContent = "_cc-f";
export var phoneShipmentPickerButtonWrapper = "_cc-d";
export var phoneShipmentPickerTrigger = "_cc-c";
export var shipmentContainer = "_cc-k";
export var shipmentDetailsMainPane = "_cc-h";
export var shipmentNavigationCard = "_cc-a";
export var shipmentNavigationEdgeTrigger = "_cc-6";
export var shipmentNavigationRail = "_cc-3";
export var shipmentNavigationRailEnter = "_cc-5";
export var shipmentNavigationRailHeader = "_cc-9";
export var shipmentNavigationRailOverlay = "_cc-4";
export var shipmentNavigationScrim = "_cc-7";
export var shipmentSummaryFact = "_cc-n";
export var shipmentSummaryGrid = "_cc-m";
export var shipmentSummaryMetadataRow = "_cc-o";
export var shipmentSummaryTags = "_cc-p";
export var shipmentWorkspace = "_cc-0";
export var shipmentWorkspaceBodyTablet = "_cc-8";
export var shipmentWorkspaceContent = "_cc-b";
export var shipmentWorkspaceHeader = "_cc-1";